import _ from 'underscore';

class ProjectList {

  constructor(el) {
    this.el = el;

    this.addEvents();
  }

  addEvents() {
    const links = this.el.querySelectorAll('ul li .scrollto');
    _.each(links, (el)=> {
        el.addEventListener('mouseenter', this.onMouseEnter)
        el.addEventListener('mouseleave', this.onMouseLeave)
    });
  }

  onMouseEnter = (event)=> {
    const target = event.currentTarget;
    this.el.style.color = target.getAttribute('data-color');
    this.el.style.background = target.getAttribute('data-background');

    // const id = target.getAttribute('data-id');
    // const img = this.el.querySelector('img.img-'+id);
    // img.classList.add('show');
  }

  onMouseLeave = ()=> {
    // const target = event.currentTarget;
    this.el.setAttribute('style','');

    // const id = target.getAttribute('data-id');
    // const img = this.el.querySelector('img.img-'+id);
    // img.classList.remove('show');
  }

}

export default ProjectList;



// WEBPACK FOOTER //
// ./src/components/sections/ProjectList.js